import { Model } from '@/models/Model';
export class GroupSubject extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'GroupSubject';
        this.$endpoint = '/groups/{id}/relationships/subjects';
        this.$fillable = [];
    }
    group(group_id) {
        this.$endpoint = `/groups/${group_id}/relationships/subjects`;
        return this;
    }
    setSubjectId(id) {
        this.id = id;
        return this;
    }
    setMassEndpoint(id) {
        this.$endpoint = `groups/${id}/relationships/subjects/mass`;
        return this;
    }
    updateMass(id, payload) {
        this.$endpoint = `groups/${id}/relationships/subjects/mass`;
        const url = this.$endpoint;
        return this.request('patch', url, this.getPayload(payload));
    }
}
export var GroupSubjectIncludes;
(function (GroupSubjectIncludes) {
    GroupSubjectIncludes["LEVEL"] = "level";
    GroupSubjectIncludes["PARENT"] = "parent";
    GroupSubjectIncludes["PERIOD"] = "period";
    GroupSubjectIncludes["SUBJECT_LABELS"] = "subject_labels";
})(GroupSubjectIncludes || (GroupSubjectIncludes = {}));
